import React, { Component, Fragment } from 'react';
import { Flex, Box, Button, Heading, Text } from 'rebass';
import ScrollAnimation from 'react-animate-on-scroll';
import { withWizard } from 'react-albus';
import { Formik, Form } from 'formik';

import { TextInput } from '../../components/TextInput';
import { TextArea } from '../../components/TextArea';
import { FormField } from '../../components/FormField';
import { APPOINTMENTS, CHARTS, CURRENT_USER, SET_AS_INACTIVE, SET_AS_INACTIVE_WEIGHTLOSS } from '../../graphql';
import { compose, Mutation, withApollo } from 'react-apollo';
import { withToastManager } from 'react-toast-notifications';
import { ButtonWithSelectionCircle, ButtonWithSelectionCircleSelectedMarkerIn, ButtonWithSelectionCircleSelectedMarkerOut } from './components/ButtonWithSelectionCircle';
import { fadeInDown, fadeInUp } from '../../utils/animationsStyleBuilder';
import { useRef } from 'react';
import { useState } from 'react';
import * as Yup from 'yup';
import gql from 'graphql-tag';

const SEND_REASON = gql`
  mutation appendIntakeNoLabChartAlert($noteToAdd: String!) {
    appendIntakeNoLabChartAlert(noteToAdd: $noteToAdd) {
      ok
    }
  }
`;

const schema = Yup.object().shape({
  date: Yup.date()
    .max(new Date(), 'You cannot choose a future date')
    .required('Date field is required!'),

  note: Yup.string()
    .trim()
    .min(2)
    .required('Required'),
});

const ErVisit = (props) => {
  const inputRef = useRef();
  const [isYesSelected, setIsYesSelected] = useState(false);

  const shiftView = () => {
    if (inputRef && inputRef.current) {
      setTimeout(() => {
        window.scrollTo(0, inputRef.offsetTop);
      }, 150);
    }
  };

  const { data, onContinue, wizard } = props;

  return (
    <Fragment>
      <Flex flex={1} flexDirection="column" style={{ zIndex: 1 }}>
        <Box m={2} style={{ ...fadeInDown() }}>
          <Text fontSize={'20px'} fontWeight={400} color="#344f77" textAlign="center">
            Did you visit the ER in the past 6 months because of your thyroid condition?
          </Text>
        </Box>

        <Flex style={{ gap: '16px' }} mb={5} mt={4} justifyContent={'center'}>
          <Button
            variant={'outline'}
            style={{ width: 'fit-content' }}
            onClick={() => {
              setIsYesSelected(true);
              shiftView();
            }}
          >
            YES
          </Button>
          <Button
            variant={'outline'}
            style={{ width: 'fit-content' }}
            onClick={() => {
              onContinue(wizard);
            }}
          >
            NO
          </Button>
        </Flex>
        {!!isYesSelected && (
          <>
            <Mutation mutation={SEND_REASON}>
              {(send, { loading, error, data }) => (
                <Formik
                  initialValues={{ date: '', note: '' }}
                  validationSchema={schema}
                  onSubmit={(values, actions) => {
                    send({
                      variables: {
                        noteToAdd: `ER visit on ${values.date}: ${values.note}`,
                      },
                    });
                    onContinue(wizard);
                    // onSubmit(payload, actions, wizard, selected);
                  }}
                  render={({ isValid, errors, touched, submitForm }) => (
                    <Form>
                      <Flex flex={1} flexDirection="column" style={{...fadeInDown(20, '0s', '200ms')}} >
                        <Text fontWeight={300} color="#344f77" textAlign="center">
                          When did you visit the ER:
                        </Text>
                        <Flex flex={1} mb={3} justifyContent="center">
                          <FormField width={[1, 1 / 2]} px={3} error={touched['date'] && errors['date']}>
                            <TextInput containerStyle={{ flex: 'initial', minWidth: '200px' }} name={'date'} type="date" placeholder="MM/DD/YYYY" />
                          </FormField>
                        </Flex>

                        <Text fontWeight={300} color="#344f77" textAlign="center">
                          Tell us more:
                        </Text>
                        <Flex flex={1} mb={4} justifyContent="center">
                          <FormField width={[1, 1 / 2]} px={3} error={touched['note'] && errors['note']}>
                            <TextArea name={'note'} placeholder={'Give us the details of the ER visit...'} />
                          </FormField>
                        </Flex>

                        <Text fontWeight={300} color="#344f77" textAlign="center" mb={4}>
                          Please send your discharge paperwork to your Paloma Health care manager or by email at <a href="mailto:contact@palomahealth.com">contact@palomahealth.com</a>
                        </Text>
                        <Flex justifyContent="center">
                          <Button disabled={!isValid} variant="pink" width={[1 / 2, 1 / 3]} type="submit">
                            Continue
                          </Button>
                        </Flex>
                      </Flex>
                    </Form>
                  )}
                />
              )}
            </Mutation>
          </>
        )}
      </Flex>
    </Fragment>
  );
};

export default compose(
  withApollo,
  withWizard,
  withToastManager
)(ErVisit);
// export default withWizard(Single);
